import { formatSplitKey } from "./FormatValue";

const handleChangeWebsiteTab = ({
  key = "",
  tabNames = null,
  setWebsiteName,
  navigated
}) => {
  navigated && navigated(true);
  setTimeout(() => {
    setWebsiteName(formatSplitKey(key, ".", tabNames) || "");
  }, 300);
};

export default handleChangeWebsiteTab;
